import React from 'react';
import { Col, Row } from 'antd';

import PortfolioCounts from '@totem/components/portfolio/overview/summary/PortfolioCounts';
import Regions from '@totem/components/portfolio/overview/summary/Regions';
import SummaryMapBoxMap from '@totem/components/portfolio/overview/summary/SummaryMapBoxMap';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';

const SummaryLayout = () => {
  return (
    <IBCard isCovered>
      <Row>
        <Col span={8}>
          <SummaryMapBoxMap />
        </Col>
        <Col span={8}>
          <PortfolioCounts />
        </Col>
        <Col span={8}>
          <Regions />
        </Col>
      </Row>
    </IBCard>
  );
};
export default SummaryLayout;
